module.exports = __webpack_public_path__ + "8fbaef3a90d5b60e413db926a988908d.MP3";